// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusSquareFilledSvg from "@ant-design/icons-svg/es/asn/GooglePlusSquareFilled";
import AntdIcon from '../components/AntdIcon';

var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusSquareFilledSvg
  }));
};

GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
export default React.forwardRef(GooglePlusSquareFilled);